/**
 * Enum for workflow types used throughout the content management system
 * This centralizes the workflow type definitions to prevent breaking changes
 * when workflow types need to be modified or extended
 */
export enum WorkflowType {
  CLASSIFICATION = 'classification',
  REPORTS = 'reports',
}
